import { toObjectTypes } from './types';
export let propertyFieldTypes;
(function (propertyFieldTypes) {
  propertyFieldTypes["phonenumber"] = "phonenumber";
  propertyFieldTypes["email"] = "email";
  propertyFieldTypes["select"] = "select";
  propertyFieldTypes["radio"] = "radio";
  propertyFieldTypes["checkbox"] = "checkbox";
  propertyFieldTypes["date"] = "date";
  propertyFieldTypes["html"] = "html";
  propertyFieldTypes["text"] = "text";
  propertyFieldTypes["number"] = "number";
  propertyFieldTypes["password"] = "password";
  propertyFieldTypes["search"] = "search";
  propertyFieldTypes["url"] = "url";
  propertyFieldTypes["tel"] = "tel";
  propertyFieldTypes["booleancheckbox"] = "booleancheckbox";
  propertyFieldTypes["textarea"] = "textarea";
  propertyFieldTypes["file"] = "file";
})(propertyFieldTypes || (propertyFieldTypes = {}));
export const propertyReferenceTypes = {
  hubspot_owner_id: 'OWNER',
  lifecyclestage: 'PIPELINE_STAGE',
  hs_all_assigned_business_unit_ids: 'BUSINESS_UNIT'
};
export const PROPERTIES_VIEWS = {
  PREVIEW_MODAL: 'PreviewModal',
  ASSOCIATION_CARD: 'AssociationCard'
};
export let propertyKeyValidationTypes;
(function (propertyKeyValidationTypes) {
  propertyKeyValidationTypes["phone"] = "phone";
  propertyKeyValidationTypes["email"] = "email";
  propertyKeyValidationTypes["linkedin_company_page"] = "linkedin_company_page";
  propertyKeyValidationTypes["domain"] = "domain";
  propertyKeyValidationTypes["lifecyclestage"] = "lifecyclestage";
  propertyKeyValidationTypes["name"] = "name";
})(propertyKeyValidationTypes || (propertyKeyValidationTypes = {}));
const PROPERTY_REFERENCE_TYPES = {
  OWNER: 'OWNER',
  TEAM: 'TEAM',
  PIPELINE: 'PIPELINE',
  PIPELINE_STAGE: 'PIPELINE_STAGE',
  MULTI_CURRENCY_CURRENCY_CODE: 'MULTI_CURRENCY_CURRENCY_CODE',
  PERSONA: 'PERSONA',
  SEQUENCE: 'SEQUENCE',
  WORKFLOW: 'WORKFLOW',
  BUSINESS_UNIT: 'BUSINESS_UNIT',
  ORIGINAL_SOURCE_1: 'ORIGINAL_SOURCE_1',
  CAMPAIGN: 'CAMPAIGN',
  TASK_QUEUE: 'TASK_QUEUE',
  CRM_OBJECT: 'CRM_OBJECT',
  USER: 'USER',
  CHANNEL_INSTANCE: 'CHANNEL_INSTANCE',
  GENERIC_CHANNEL: 'GENERIC_CHANNEL',
  TRACKED_TERM: 'TRACKED_TERM',
  SEQUENCE_WITH_PERMISSIONS: 'SEQUENCE_WITH_PERMISSIONS',
  PIPELINE_WITH_PERMISSIONS: 'PIPELINE_WITH_PERMISSIONS',
  PIPELINE_STAGE_WITH_PERMISSIONS: 'PIPELINE_STAGE_WITH_PERMISSIONS',
  CRM_OBJECT_TAG: 'CRM_OBJECT_TAG',
  STATIC_INBOUND_DB_LIST: 'STATIC_INBOUND_DB_LIST',
  OPTIMIZATION_TYPE: 'OPTIMIZATION_TYPE',
  CALL_DISPOSITION: 'CALL_DISPOSITION'
};
export const PROPERTY_NAME_TO_REFERENCE_TYPE = {
  [toObjectTypes.contact]: {},
  [toObjectTypes.company]: {},
  [toObjectTypes.deal]: {
    pipeline: PROPERTY_REFERENCE_TYPES.PIPELINE,
    dealstage: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE,
    deal_currency_code: PROPERTY_REFERENCE_TYPES.MULTI_CURRENCY_CURRENCY_CODE
  },
  [toObjectTypes.ticket]: {
    hs_pipeline: PROPERTY_REFERENCE_TYPES.PIPELINE,
    hs_pipeline_stage: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE
  },
  [toObjectTypes.meeting]: {}
};
export const matchPropertyTypeToInput = {
  [propertyFieldTypes.phonenumber]: 'tel',
  [propertyFieldTypes.email]: propertyFieldTypes.email,
  [propertyFieldTypes.select]: propertyFieldTypes.select,
  [propertyFieldTypes.radio]: propertyFieldTypes.radio,
  [propertyFieldTypes.checkbox]: propertyFieldTypes.checkbox,
  [propertyFieldTypes.date]: propertyFieldTypes.date,
  [propertyFieldTypes.html]: 'text',
  [propertyFieldTypes.text]: propertyFieldTypes.text,
  [propertyFieldTypes.number]: propertyFieldTypes.number,
  [propertyFieldTypes.password]: propertyFieldTypes.password,
  [propertyFieldTypes.search]: propertyFieldTypes.search,
  [propertyFieldTypes.url]: propertyFieldTypes.url,
  [propertyFieldTypes.tel]: propertyFieldTypes.tel,
  [propertyFieldTypes.booleancheckbox]: propertyFieldTypes.booleancheckbox,
  [propertyFieldTypes.textarea]: propertyFieldTypes.textarea,
  [propertyFieldTypes.file]: propertyFieldTypes.file
};
export const PROPERTIES_LIMIT = 50;